// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { formatShortDate } from '@/utilities/date-time';
import { DateTime } from 'luxon';

// Format a date/timestamp as "Mon DD, YYYY" for display inside the hover
// markers on the per-invoice Gantt. Returns null when the anchor is absent.
export function formatAnchorDate(value: DateTime | null): string | null {
  if (value === null) return null;
  return formatShortDate(value);
}

// Render a signed day value as an accounting-style label — 1 decimal,
// negatives wrapped in parentheses with the sign suppressed. Matches the
// financial-report convention for contra values like "days paid early".
// The unit suffix stays inside the parens so the wrap reads as a single
// token rather than a negated-then-unit pair.
export function formatDays(value: number): string {
  const rounded = Math.abs(value).toFixed(1);
  if (value < 0) {
    return `(${rounded}d)`;
  }
  return `${rounded}d`;
}
